import type { Context } from '../../../overmind';
import { routes } from '../../../overmind/machines/router';

export const handlePresentCalculationSetExecutionResultsRoute = (
  context: Context
) => ({
  [routes.calculationv2]: () => {
    if (context.state.calculation.calculationTactic.matches('LOADED')) {
      context.actions.internal.setRoute({ route: 'calculationv2' });
    } else {
      context.actions.internal.setRoute({
        route: 'root'
      });
    }
  }
});
